ALKMaps.Control.YardSnapping = ALKMaps.Class(ALKMaps.Control.Snapping, {


  CLASS_NAME: "ALKMaps.Control.YardSnapping"
});


// WEBPACK FOOTER //
// ./app/alkmapsExtension/controlYardSnapping.js